/* eslint-disable */
// https://akryum.github.io/vue-apollo/zh-cn/guide/apollo/
import gql from 'graphql-tag';
import * as utils from '@/utils/util'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import fetch from 'unfetch'

const gqlApi = {};
switch(utils.getEnv()) {
  case 'pre':
    {
      gqlApi.host = 'http://pre-api.duanshu.com/fairy/mgql';
      break;
    }
  case 'dev':
  case 'test':
    {
      gqlApi.host = 'http://test-api.duanshu.com/fairy/mgql';
      break;
    }
  default:
    {
      gqlApi.host = 'http://api.duanshu.com/fairy/mgql';
    }
}
const httpLink = new HttpLink({
  // 你需要在这里使用绝对路径
  // uri: 'http://localhost:3020/graphql',
  // uri: "https://api.graphcms.com/simple/v1/awesomeTalksClone"
  // uri: 'https://nnnwvmq07.lp.gql.zone/graphql'
  credentials: 'include',
  uri: gqlApi.host,
  fetch(uri, options) {
    // var loginData = '';
    // if (localStorage.getItem('loginData')) {
    //   try{
    //     loginData =  JSON.parse(localStorage.getItem('loginData')).shop;
    //     options.headers['x-shop'] = loginData.id
    //   } catch (e) {
    //   }
		// }
    return fetch(uri, options)
  }
})

// 创建 apollo 客户端
const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: false,
  defaultOptions: {
    // 将应用于组件中的所有查询的 apollo 选项
    query: {
      loadingKey: 'loading',
      fetchPolicy: 'network-only', // cache-first, cache-and-network, network-only, cache-only
    },
  },
})

export const api = {
  query: (gqlQuery, params) => {
    return apolloClient.query({
      'query': gqlQuery,
      // fetchPolicy: 'network-only',
      'variables': params,
    }).then(res => {
      // console.log('res: ', res);
      // console.log('error: ', res.error);
      // console.log('loading: ', res.loading);
      // console.log('networkStatus: ', res.networkStatus);
      if (res && res.data) {
        for (let key in res.data) {
          if (res.data.hasOwnProperty(key) && res.data[key] && res.data[key].errors && res.data[key].errors.length > 0) {
            return Promise.reject({ code: 200, error: res.data[key].errors[0], message: res.data[key].errors[0] });
          }
        }
      }
      return Promise.resolve(res);
    }, ({ graphQLErrors, networkError }) => {
      // console.log(rej);
      // console.dir(networkError);
      // console.log('graphQLErrors: ', graphQLErrors);
      // console.log('networkError result: ', networkError.result);
      // console.log('networkError statusCode: ', networkError.statusCode);
      // console.log('networkError status: ', networkError.response.status);
      // console.log('networkError statusText: ', networkError.response.statusText);
      if (networkError.statusCode == 403) {
        utils.msg.warning('抱歉，您的登录已过期，请重新登录');
        // login.clearUserInfo();
        window.myVue.$router.replace({ name: 'login' });
      } else {
        return Promise.reject({ code: networkError.statusCode, error: networkError.result.response, message: networkError.result.response });
      }
    });
  },

  mutate: (gqlMutate, params) => {
    return apolloClient.mutate({
      'mutation': gqlMutate,
      // fetchPolicy: 'network-only',
      'variables': { 'input': params },
    }).then(res => {
      // console.log('res: ', res);
      // console.log('error: ', res.error);
      // console.log('loading: ', res.loading);
      // console.log('networkStatus: ', res.networkStatus);
      // console.log(res);
      if (res && res.error && res.error.length > 0) {
        return Promise.reject({ code: 200, error: res.error[0].message, message: res.error[0].message });
      }
      if (res && res.data) {
        for (let key in res.data) {
          if (res.data.hasOwnProperty(key) && res.data[key] && res.data[key].errors && res.data[key].errors.length > 0) {
            return Promise.reject({ code: 200, error: res.data[key].errors[0].messages[0], message: res.data[key].errors[0].messages[0] });
          }
        }
      }
      return Promise.resolve(res);
    }, ({ graphQLErrors, networkError }) => {
      // console.dir(networkError);
      // console.log('graphQLErrors: ', graphQLErrors);
      // console.log('networkError result: ', networkError.result);
      // console.log('networkError statusCode: ', networkError.statusCode);
      // console.log('networkError status: ', networkError.response.status);
      // console.log('networkError statusText: ', networkError.response.statusText);
      if (networkError && networkError.statusCode == 403) {
        utils.msg.warning('抱歉，您的登录已过期，请重新登录');
        // login.clearUserInfo();
        window.myVue.$router.replace({ name: 'login' });
      } else if (graphQLErrors.length > 0) {
        return Promise.reject({
          error: graphQLErrors[0].message,
          message: graphQLErrors[0].message
        });
      } else {
        return Promise.reject({
          code: networkError.statusCode,
          error: (networkError.result.errors && networkError.result.errors.length > 0) ? networkError.result.errors[0] : networkError.message,
          message: (networkError.result.errors && networkError.result.errors.length > 0) ? networkError.result.errors[0] : networkError.message
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/api-gql/api.js